import request from '@/utils/analyticsRequest'

export function listAiAgents() {
  return request({ url: '/api/v1/ghl/ai/agents', method: 'get' })
}

export function getAiAgent(id) {
  return request({ url: `/api/v1/ghl/ai/agents/${id}`, method: 'get' })
}

export function createAiAgent(data) {
  return request({
    url: '/api/v1/ghl/ai/agents',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/json' }
  })
}

export function updateAiAgent(id, data) {
  return request({
    url: `/api/v1/ghl/ai/agents/${id}`,
    method: 'put',
    data,
    headers: { 'Content-Type': 'application/json' }
  })
}

export function deleteAiAgent(id) {
  return request({ url: `/api/v1/ghl/ai/agents/${id}`, method: 'delete' })
}

export function generateFollowUpMessage(id, data) {
  return request({
    url: `/api/v1/ghl/ai/agents/${id}/generate-follow-up`,
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/json' }
  })
}

export function listPlaygroundMessages(agentId) {
  return request({
    url: `/api/v1/ghl/ai/agents/${agentId}/playground/messages`,
    method: 'get'
  })
}

export function sendPlaygroundMessage(agentId, message) {
  return request({
    url: `/api/v1/ghl/ai/agents/${agentId}/playground/messages`,
    method: 'post',
    data: { message },
    headers: { 'Content-Type': 'application/json' },
    timeout: 35000
  })
}

export function resetPlaygroundConversation(agentId) {
  return request({
    url: `/api/v1/ghl/ai/agents/${agentId}/playground/reset`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' }
  })
}
